import Head from "next/head";
import { useEffect, useState } from "react";

import { AppConfig } from "@/config/app.config";
import { DemoContext } from "@/providers/demo/DemoContext";

/**
 * Dynamic favicon component that switches favicons based on:
 * 1. Demo mode (uses dev favicon)
 * 2. Dev/local environment (uses favicon-dev.png for all sizes)
 * 3. Default (production/staging - uses separate 16x16 and 32x32 favicons)
 */
export const DynamicFavicon = () => {
  const { isDemoMode } = DemoContext.useDemo();
  const [favicon16, setFavicon16] = useState("/favicon-16x16.png");
  const [favicon32, setFavicon32] = useState("/favicon-32x32.png");

  useEffect(() => {
    const isDevEnvironment =
      AppConfig.stage === "dev" || AppConfig.stage === "development" || AppConfig.stage === "local";

    // Priority: Demo mode > Dev environment > Default
    if (isDemoMode || isDevEnvironment) {
      // Dev/demo: use single favicon-dev.png for all sizes
      setFavicon16("/favicon-dev.png");
      setFavicon32("/favicon-dev.png");
    } else {
      // Production/staging: use separate favicons for different sizes
      setFavicon16("/favicon-16x16.png");
      setFavicon32("/favicon-32x32.png");
    }
  }, [isDemoMode]);

  return (
    <Head>
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={favicon32}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={favicon16}
      />
    </Head>
  );
};
